import React from 'react'
import styled from 'styled-components'
import { Row } from 'components/common/layout'
import Image from 'next/legacy/image'
import { SmallText } from 'components/common/text'

export enum CheckBoxSize {
  SMALL = 16,
  DEFAULT = 18,
  LARGE = 24,
} // 체크박스 사이즈

export enum CheckBoxType {
  SMALL = 2,
  DEFAULT = 2,
  ROUND = 100,
} // 체크 아이콘 border radius

export const CheckBox: React.FCC<{
  checked: boolean
  onClick: () => void
  color?: string
  size?: CheckBoxSize
  type?: CheckBoxType
  disabled?: boolean // 추가
}> = ({
  checked,
  onClick,
  children,
  color,
  size = CheckBoxSize.DEFAULT,
  type = CheckBoxType.DEFAULT,
  disabled = false, // 추가
}) => {
  return (
    <Main onClick={disabled ? undefined : onClick} disabled={disabled}>
      <IconBox
        isChecked={checked}
        color={color}
        size={size}
        type={type}
        disabled={disabled} // 추가
      >
        {checked ? (
          <Image
            src='/check-white1.svg'
            height={size}
            width={size}
            alt='checked'
            style={{ opacity: disabled ? 0.5 : 1 }} // 추가
          />
        ) : (
          <Image
            src='/check.svg'
            height={size}
            width={size}
            alt='unchecked'
            style={{ opacity: disabled ? 0.5 : 1 }} // 추가
          />
        )}
      </IconBox>
      {children && <SubText disabled={disabled}>{children}</SubText>}
    </Main>
  )
}

const Main = styled(Row)<{ disabled?: boolean }>`
  gap: 8px;
  flex: none;
  user-select: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  cursor: ${(p) => (p.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(p) => (p.disabled ? 0.6 : 1)};
`

const IconBox = styled(Row)<{
  isChecked: boolean
  size: CheckBoxSize
  type: CheckBoxType
  color?: string
  disabled?: boolean // 추가
}>`
  width: ${(p) => p.size}px;
  height: ${(p) => p.size}px;
  border-radius: ${(p) => p.type}px;
  background-color: ${(p) =>
    p.isChecked ? p.color || p.theme.color.secondary : p.theme.color.white1};
  border: 1px solid
    ${(p) =>
      p.isChecked ? p.color || p.theme.color.secondary : p.theme.color.gray2};
  opacity: ${(p) => (p.disabled ? 0.5 : 1)};
  pointer-events: ${(p) => (p.disabled ? 'none' : 'auto')};
`

const SubText = styled(SmallText)<{ disabled?: boolean }>`
  color: ${(p) => p.theme.color.black2};
  opacity: ${(p) => (p.disabled ? 0.5 : 1)};
`
